import { Box, Grid, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";

export const WeChatQRCode: FC = () => {
  // responsive UI
  const theme = useTheme();
  // const notPhone = useMediaQuery(theme.breakpoints.up("sm"));

  return (
    <Grid size={{ xs: 12, sm: 4 }}>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "5px",
          padding: "16px",
          gap: "16px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <TipsAndUpdatesIcon
            color="secondary"
            sx={{ width: "18px", height: "18px" }}
          />
          <Typography
            variant="h5"
            color="secondary"
            fontStyle="italic"
            fontWeight={700}
          >
            天堂相册
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "16px 0",
            height: "150px",
          }}
        >
          <img
            src={"qrCode/lingqi-aigc-portal.png"}
            alt={`mini program`}
            style={{
              width: "150px",
              height: "150px",
              border: `1px solid ${theme.palette.secondary.dark}`,
              boxShadow: `0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)`,
              borderRadius: "30%",
            }}
          />
        </Box>
      </Box>
    </Grid>
  );
};
